import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Workflow } from '@models/workflow.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyService } from '@services/company.service';
import { Toaster } from '@services/toaster.service';
import { LocalStorage } from 'ngx-webstorage';
import { BehaviorSubject, forkJoin, Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import CONFIG from '@app/app.config';

@Component({
  selector: 'ngx-workflow-creation',
  templateUrl: './workflow-creation-modal.component.html',
  styleUrls: ['./workflow-creation-modal.component.scss'],
})
export class WorkflowCreationModalComponent implements OnInit, OnDestroy {
  workflowForm: FormGroup;

  @Input() organizationId;
  @Input() workflow: Workflow;

  constructor(
    private ngbActiveModal: NgbActiveModal,
    private fb: FormBuilder,
    private $company: CompanyService,
    private $toaster: Toaster,
  ) {
  }

  ngOnInit() {
    this.workflowForm = this.fb.group({
      name: [null, [Validators.required]],
      description: [null, [Validators.required]],
      is_enabled: [true, [Validators.required]],
    });

    if (this.workflow && this.workflow.id) {
      this.workflowForm.patchValue(this.workflow);
    }
  }

  save() {
    if (this.workflowForm.valid) {
      const workflowPayload = new Workflow(this.workflowForm.getRawValue());
      let request;

      if (this.workflow && this.workflow.id) {
        request = this.$company.updateWorkflow(
          this.organizationId, this.workflow.id, workflowPayload,
        );
      } else {
        request = this.$company.createWorkflow(
          this.organizationId, workflowPayload,
        );
      }

      request.subscribe((result) => {
        if (this.workflow && this.workflow.id) {
          this.$toaster.show('success', 'Success', 'Workflow has been updated');
        } else {
          this.$toaster.show('success', 'Success', 'Workflow has been added');
        }
        this.ngbActiveModal.close(result);
      }, (e) => {
        const errMsg = !!e.error && !!e.error.detail ? e.error.detail : e.message;
        this.$toaster.show('error', 'An error occurred', 'Please try again later');
      });
    }
  }

  closeModal() {
    this.ngbActiveModal.dismiss();
  }

  ngOnDestroy(): void {
  }

}
